export const authBackgroundImg = 'assets/images/backgrounds/wecan-auth-bg.jpg';
